<div class="step-content">
  <app-dashboard-box [title]="'common.title.device-administration' | translate"
                     class="transparent device-filter"
                     [buttonLabel]="'common.actions.reset-filter' | translate"
                     [buttonIconName]="'refresh'"
                     (buttonClick)="resetFilter()"
                     icon="filter_alt">

    <section class="filter-section">
      <app-input-text [formData]="searchConfig" />
      <app-input-select [formData]="statusSelect" />
      <app-input-select [formData]="modelSelect" />
    </section>
  </app-dashboard-box>

  <app-dashboard-box [buttonLabel]="deviceCountLabel"
                     [title]="'common.title.device-list' | translate"
                     icon="list">
    <app-table [tableConfig]="tableConfig"
               [tableRows]="tableRows"
               [loading]="loading" />
  </app-dashboard-box>
</div>
